import React from 'react';

import { useByfunnPulseContext } from '../../../pulse/index.js';

export interface SectionBarProps {
  activeSection: string;
  setActiveSection: (text: string) => void;
}

export const SectionBar: React.FC<SectionBarProps> = ({
  activeSection,
  setActiveSection,
}) => {
  const props = {
    activeSection,
    setActiveSection,
  };

  return (
    <div className="section-bar-container">
      <SectionButton {...props} name="Mat & Drikke" slug="mat-og-drikke" />
      <SectionButton {...props} name="Film & Serier" slug="film-og-serier" />
      <SectionButton {...props} name="Byliv & Guider" slug="byliv-og-guider" />
    </div>
  );
};

interface SectionButtonProps extends SectionBarProps {
  name: string;
  slug: string;
}

const SectionButton: React.FC<SectionButtonProps> = ({
  activeSection,
  setActiveSection,
  name,
  slug,
}) => {
  const { trackClickUIElement } = useByfunnPulseContext();

  const handleClick = (): void => {
    setActiveSection(slug);

    trackClickUIElement(
      {
        object: {
          id: `section-bar-button:${slug}`,
          name: `click section button: ${name}`,
          elementType: 'Button',
        },
      },
      {
        object: {
          objectId: `section-bar-button:${slug}`,
          name: `click section button: ${name}`,
          elementType: 'Button',
        },
        placement: { containerName: 'page' },
      },
    );
  };

  return (
    <button
      className={`section-bar-button ${slug} ${
        activeSection === slug ? 'active' : 'inactive'
      }`}
      onClick={handleClick}
    >
      {name}
    </button>
  );
};
